import { CheckSVG, CopySVG } from '@media/svgs'
import { useCopyToClipboard } from '@hooks/useCopyToClipboard'
import { buildVerificationReport } from '@core/provablyFair/verificationReport'

// Copy control for the round's verification block. The text itself is built in
// core/provablyFair/verificationReport.js — it is verified against real rounds by
// the engine's test suite, which cannot import a component.
const AiVerificationBlock = ({ round, gameCode }) => {
  const { copy, isCopied } = useCopyToClipboard({ resetAfterMs: 2000 })
  const report = buildVerificationReport(round, gameCode)
  const copied = isCopied('ai-report')

  return (
    <div className="standard-normal-provably-fair-ai">
      <div className="standard-normal-provably-fair-hash-header">
        <span className="standard-normal-provably-fair-hash-label">Check this round with AI</span>
        <button
          type="button"
          className={`standard-normal-provably-fair-copy ${copied ? 'is-copied' : ''}`}
          onClick={() => copy(report, 'ai-report')}
          aria-label={copied ? 'Verification summary copied' : 'Copy verification summary'}
          title={copied ? 'Copied' : 'Copy'}
        >
          {copied ? <CheckSVG /> : <CopySVG />}
        </button>
      </div>

      <p className="standard-normal-provably-fair-note">
        Copy this and paste it into any AI chat, then ask it to check this round. Everything it
        needs is in there — you don&apos;t have to understand any of it.
      </p>

      {copied && (
        <span className="standard-normal-provably-fair-ai-ack">
          Copied — now paste it into an AI chat.
        </span>
      )}
    </div>
  )
}

export default AiVerificationBlock
